export const commonTooltipInlineStyle = { 
    width: 130, 
    fontSize: 13,
    textAlign: 'center',
    color: '#ffffff', 
    zIndex: 999 
};